import type { DashboardIconName } from './DashboardIcon';

type QuickLink = {
  href: string;
  icon: DashboardIconName;
  label: string;
  description: string;
};

export const quickLinks: QuickLink[] = [
  {
    href: '/trips',
    icon: 'map',
    label: 'Guarantees',
    description: 'View every guarantee',
  },
  {
    href: '/payout-management',
    icon: 'wallet',
    label: 'Payout Accounts',
    description: 'Manage payout details',
  },
  {
    href: '/profile',
    icon: 'profile',
    label: 'Profile',
    description: 'Update account settings',
  },
];
